module.exports = __webpack_public_path__ + "static/key-visual-ca1ae0bada49019dd945e6d5cef6ca37.svg";